/**
 * @typedef {WherebyRoomConnectionDescriptor | LocalRoomConnectionDescriptor} RoomConnectionDescriptor
 *
 * @typedef {Object} WherebyRoomConnectionDescriptor
 * @property {'Whereby'} type
 * @property {string} roomUrl
 *
 * @typedef {Object LocalRoomConnectionDescriptor}
 * @property {'Local'} type
 *
 * @param {import('../API').RoomConnectionDescriptorDTO} descriptor
 * @returns {RoomConnectionDescriptor}
 */
export function mapConnectionDescriptorFromDto(descriptor) {
  switch (descriptor.type) {
    case 'Whereby':
      return {
        type: 'Whereby',
        roomUrl: descriptor.room_url
      };
    case 'Local':
      return {
        type: 'Local'
      };
  }
}
//# sourceMappingURL=ConnectionDescriptor.js.map
